import api from "api";

export function getZohoData(query, pageNumber, startDate, endDate) {
  return api.get(
    `${query}?pageSize=10&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`
  );
}